export default __webpack_public_path__ + "static/media/Order.35f7c690.jpg";